class CartRedirect extends HTMLElement {
    constructor() {
        super();
        this.cart = null;
    }

    connectedCallback() {
        this.openCartDrawer();
        this.loadContentFromUrl();
    }

    openCartDrawer() {
        this.cart = document.querySelector('cart-drawer');
        if (this.cart && typeof this.cart.open === 'function') {
            this.cart.open();
        } else {
            console.error('Cart drawer element not found or does not have an open method.');
        }
    }

    async loadContentFromUrl() {
        const dataUrl = this.getAttribute('data-url');

        if (!dataUrl) {
            console.error('The data-url attribute is missing.');
            return;
        }

        try {
            const response = await fetch(dataUrl);

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
            }

            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            this.replaceContent(doc);
            this.updatePageTitle(doc);
        } catch (error) {
            console.error('Error fetching content:', error);
        }
    }

    replaceContent(doc) {
        const mainContent = doc.querySelector('#MainContent');

        if (mainContent) {
            this.innerHTML = mainContent.innerHTML;
            console.log('Cart redirect content replaced successfully.');
        } else {
            console.error('#MainContent not found in the fetched HTML.');
        }
    }

    updatePageTitle(doc) {
        const newTitle = doc.querySelector('title')?.textContent;

        if (newTitle) {
            document.title = newTitle;
            console.log('Page title updated:', newTitle);
        } else {
            console.warn('No title found in the fetched HTML.');
        }
    }
}

// Define the new element
customElements.define('cart-redirect', CartRedirect);